@import '../../assets/scss/main';

.PaginationHost {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
}

.PaginationBlockHitbox {
    padding: 1em 15px;
}

.PaginationBlock {
    height: 4px;
    width: 30px;
    border-radius: 2px;
    background-color: #dddddd;
}

.PaginationBlockActive {
    background-color: $primary;
}
